import { useEffect, useRef, useState } from 'react';

export function useDelayedUnmount(visible?: boolean, delay: number = 200) {
  const [show, setShow] = useState(visible);
  const [hide, setHide] = useState(!visible);
  const timeoutRef = useRef<number | undefined>();

  useEffect(() => {
    if (visible) {
      setShow(true);
      setHide(false);
      clearTimeout(timeoutRef.current);
    } else {
      setShow(false);
      timeoutRef.current = window.setTimeout(() => setHide(true), delay);
    }
  }, [delay, visible]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return {
    unmounting: !show,
    show: !hide
  };
}
